import React from 'react';
import PropTypes from 'prop-types';

import styles from './hubError.scss';

const DEFAULT_ERROR_MESSAGE = 'We couldn\'t load your lists. Please try again.';
const RETRY_LABEL = 'Retry';

const HubError = ({ 'data-testid': dataTestId, onRetry, message }) => (
    <div className={styles.hubError} data-testid={dataTestId || undefined}>
        <span className={styles.message} data-testid={dataTestId && `${dataTestId}.message`}>
            {message}
        </span>
        <button
            type="button"
            className={styles.retryBtn}
            onClick={onRetry}
            data-testid={dataTestId && `${dataTestId}.retry-btn`}
        >
            {RETRY_LABEL}
        </button>
    </div>
);

HubError.propTypes = {
    'data-testid': PropTypes.string,
    onRetry: PropTypes.func.isRequired,
    message: PropTypes.string,
};

HubError.defaultProps = {
    'data-testid': null,
    message: DEFAULT_ERROR_MESSAGE,
};

export default HubError;
